exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-f46dfa30] .el-switch .el-switch__label{position:absolute;display:none;color:#fff}[data-v-f46dfa30] .el-switch .el-switch__label.is-active{display:block}[data-v-f46dfa30] .el-switch .el-switch__label,[data-v-f46dfa30] .el-switch .el-switch__label .el-switch__core{width:50px!important}[data-v-f46dfa30] .el-switch .el-switch__label--left{left:20px;z-index:9}[data-v-f46dfa30] .el-switch .el-switch__label--right{left:-3px;z-index:9}.icon_hover[data-v-f46dfa30]:hover{color:#31b6f9}", ""]);

// exports
